const CollectionFilterDetails = (el, onChangeFilterParams) => {


  let filterParams = []
  let filterParamsInitialized = false


  const initialize = () => {
    filterParamsInitialized = false

    el.querySelectorAll('.fs-header-row').forEach(headerRow => {
      headerRow.addEventListener('click', e => {
        headerRow.parentElement.classList.toggle('show')
      })
    })

    el.querySelectorAll('input').forEach(input => {

      if (input.type == 'number') {
        input.addEventListener('input', e => {
          const newFilterParams = filterParams.filter(kv => kv.key != e.target.name)
          if (!e.target.value || e.target.value.length <= 0) {
            onChangeFilterParams(newFilterParams)
          } else {
            onChangeFilterParams([...newFilterParams, {key: e.target.name, value: e.target.value}])
          }
        })
        return
      }

      input.addEventListener('change', e => {

        if (e.target.name == 'detail_length_range_enabled') {
          if (e.target.checked) {
            el.querySelector('.fs-range-row-container')?.classList.add('show')
          } else {
            el.querySelector('.fs-range-row-container')?.classList.remove('show')
            const newFilterParams = filterParams.filter(kv => !kv.key.startsWith('detail_length_'))
            onChangeFilterParams(newFilterParams)
          }
          return
        }

        if (e.target.checked) {
          onChangeFilterParams([...filterParams, {key: e.target.name, value: e.target.value}])
          return
        }
        const newFilterParams = filterParams.filter(kv => kv.key != e.target.name || kv.value != e.target.value)
        onChangeFilterParams(newFilterParams)
      })
    })
  }


  const setFilterParams = (newFilterParams) => {
    filterParams = newFilterParams

    el.querySelectorAll('input[type=number]').forEach(input => {
      input.value = filterParams?.find(kv => kv.key == input.name)?.value ?? null
    })

    el.querySelectorAll('input[type=checkbox]').forEach(input => {
      if (input.name != 'detail_length_range_enabled') {
        input.checked = false
        if (0 <= filterParams?.findIndex(kv => kv.key == input.name && kv.value == input.value)) {
          input.checked = true
        }
      }
    })

    if (!filterParamsInitialized) {
      filterParamsInitialized = true

      if (0 < filterParams.findIndex(kv => kv.key == 'meta.custom.detail_sleeve')) {
        el.querySelector('.fs-submenu.sleeve').classList.add('show')
      }
      if (0 < filterParams.findIndex(kv => kv.key == 'meta.custom.detail_length')) {
        el.querySelector('.fs-submenu.length').classList.add('show')
      }
      if (0 < filterParams.findIndex(kv => kv.key.startsWith('detail_length_'))) {
        el.querySelector('.fs-submenu.length').classList.add('show')
        el.querySelector('.fs-range-row-container').classList.add('show')
        el.querySelector('input[name=detail_length_range_enabled]').checked = true
      }
      if (0 < filterParams.findIndex(kv => kv.key == 'meta.custom.detail_silhouette')) {
        el.querySelector('.fs-submenu.silhouette').classList.add('show')
      }
    }
  }


  initialize()

  return {
    setFilterParams: setFilterParams
  }
}


export default CollectionFilterDetails
